import { Observable, of } from 'rxjs';

import { TomarListaCarga, TomarListaPersona } from './tomar-lista.model';

/** Contrato de la planilla. La pantalla usa `TomarListaService` (HTTP). */
export abstract class TomarListaDataSource {
  abstract cargar(idLider?: string): Observable<TomarListaCarga>;
  abstract enviar(personas: TomarListaPersona[]): Observable<void>;

  ultima(_idLider?: string): Observable<string | null> {
    void _idLider;
    return of(null);
  }
}
